import { FinalRoundMemberEntity } from "@/modules/boxDashboard/modules/FinalRoundMembers/entities/finalRoundMemberEntity"
import type { HUImage } from "@/modules/types/imageTypes"

const INITIAL_DISPLAY_COUNT = 6

export type FinalRoundMemberModel = {
  id: string
  memberId: string
  fullName: string
  avatar: HUImage | null
  offerName: string
  badgeLabel: string
  endDate: string
  sessionsLast30Days: number
}

export function createFinalRoundMemberModel(entity: FinalRoundMemberEntity): FinalRoundMemberModel {
  return {
    id: entity.id,
    memberId: entity.memberId,
    fullName: entity.getFullName(),
    avatar: entity.avatar,
    offerName: entity.purchaseName,
    badgeLabel: entity.getBadgeLabel(),
    endDate: entity.getEndDateFormatted(),
    sessionsLast30Days: entity.sessionsLast30Days,
  }
}

export type FinalRoundMembersBlockModel = {
  members: FinalRoundMemberModel[]
  totalCount: number
  hasMembers: boolean
  isEmpty: boolean
  showShowMore: boolean
  showShowLess: boolean
  showPagination: boolean
  currentPage: number
  totalPages: number
  displayedCount: number
}

export type CreateFinalRoundMembersBlockModelParams = {
  members: FinalRoundMemberEntity[]
  totalCount: number
  currentPage: number
  pageSize: number
  isExpanded: boolean
}

export function createFinalRoundMembersBlockModel(
  params: CreateFinalRoundMembersBlockModelParams,
): FinalRoundMembersBlockModel {
  const { members, totalCount, currentPage, pageSize, isExpanded } = params

  const memberModels = members.map(createFinalRoundMemberModel)
  const hasMembers = totalCount > 0
  const isEmpty = totalCount === 0

  let displayedMembers: FinalRoundMemberModel[]
  let displayedCount: number

  if (isExpanded) {
    // When expanded, show all results for the current page
    displayedMembers = memberModels
    displayedCount = displayedMembers.length
  } else {
    displayedCount = Math.min(memberModels.length, INITIAL_DISPLAY_COUNT)
    displayedMembers = memberModels.slice(0, displayedCount)
  }

  const showShowMore = !isExpanded && totalCount > INITIAL_DISPLAY_COUNT

  const totalPages = Math.ceil(totalCount / pageSize)

  return {
    members: displayedMembers,
    totalCount,
    hasMembers,
    isEmpty,
    showShowMore,
    showShowLess: isExpanded,
    showPagination: totalPages > 1,
    currentPage,
    totalPages,
    displayedCount,
  }
}
